import {
  readAppEnvironment,
  readString,
  type AppEnvironment,
  type EnvironmentSource,
} from '@autocontrol/config';

import { DEFAULT_DEV_API_BASE_URL, normalizeApiBaseUrl } from './api-base-url';

export interface WebRuntimeConfig {
  readonly appEnv: AppEnvironment;
  readonly apiBaseUrl: string;
}

/**
 * Reads technical runtime settings exposed by Vite. Only variables prefixed with
 * `VITE_` reach the browser bundle; secrets must never use that prefix.
 *
 * Default `VITE_API_BASE_URL` is relative `/api/v1` so local DEV Admin traffic
 * stays same-origin with the Vite server (and its `/api/v1` proxy). Absolute
 * bases remain supported for production/external deployments.
 */
export function loadWebRuntimeConfig(
  source: EnvironmentSource = import.meta.env as unknown as EnvironmentSource,
): WebRuntimeConfig {
  return {
    appEnv: readAppEnvironment(source, 'VITE_APP_ENV'),
    apiBaseUrl: normalizeApiBaseUrl(
      readString(source, 'VITE_API_BASE_URL', DEFAULT_DEV_API_BASE_URL),
    ),
  };
}
